// source: messaging/camera_status.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var messaging_camera_settings_pb = require('../messaging/camera_settings_pb.js');
goog.object.extend(proto, messaging_camera_settings_pb);
var messaging_live_control_pb = require('../messaging/live_control_pb.js');
goog.object.extend(proto, messaging_live_control_pb);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraRuntimeStatus', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraRuntimeStatus.Membership', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.PowerSource', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraStatusControls', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.LiveSessionStatus', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.alfredcamera.protobuf.CameraRuntimeStatus.repeatedFields_, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraRuntimeStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraRuntimeStatus.displayName = 'proto.com.alfredcamera.protobuf.CameraRuntimeStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.displayName = 'proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.displayName = 'proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.displayName = 'proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.LiveSessionStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.LiveSessionStatus.displayName = 'proto.com.alfredcamera.protobuf.LiveSessionStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.displayName = 'proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.displayName = 'proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.repeatedFields_ = [8,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraRuntimeStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    settingsRevision: jspb.Message.getFieldWithDefault(msg, 1, 0),
    disabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    micOff: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    powerStatus: (f = msg.getPowerStatus()) && proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.toObject(includeInstance, f),
    membershipStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    detectorStatus: (f = msg.getDetectorStatus()) && proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.toObject(includeInstance, f),
    healthStatus: (f = msg.getHealthStatus()) && proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.toObject(includeInstance, f),
    connectedUsersList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    statusCodesList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraRuntimeStatus;
  return proto.com.alfredcamera.protobuf.CameraRuntimeStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSettingsRevision(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMicOff(value);
      break;
    case 4:
      var value = new proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.deserializeBinaryFromReader);
      msg.setPowerStatus(value);
      break;
    case 5:
      var value = /** @type {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.Membership} */ (reader.readEnum());
      msg.setMembershipStatus(value);
      break;
    case 6:
      var value = new proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.deserializeBinaryFromReader);
      msg.setDetectorStatus(value);
      break;
    case 7:
      var value = new proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.deserializeBinaryFromReader);
      msg.setHealthStatus(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addConnectedUsers(value);
      break;
    case 15:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addStatusCodes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraRuntimeStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettingsRevision();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMicOff();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getPowerStatus();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.serializeBinaryToWriter
    );
  }
  f = message.getMembershipStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getDetectorStatus();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.serializeBinaryToWriter
    );
  }
  f = message.getHealthStatus();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.serializeBinaryToWriter
    );
  }
  f = message.getConnectedUsersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getStatusCodesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      15,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.Membership = {
  FREE: 0,
  FREE_2: 1,
  PLUS: 4,
  PLUS_2: 5,
  PREMIUM: 8,
  PREMIUM_2: 9
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    batteryLevel: jspb.Message.getFieldWithDefault(msg, 1, 0),
    powerSource: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus;
  return proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBatteryLevel(value);
      break;
    case 2:
      var value = /** @type {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.PowerSource} */ (reader.readEnum());
      msg.setPowerSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBatteryLevel();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPowerSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.PowerSource = {
  AC: 0,
  BATTERY: 1,
  USB: 2
};

/**
 * optional int32 battery_level = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.prototype.getBatteryLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.prototype.setBatteryLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional PowerSource power_source = 2;
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.PowerSource}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.prototype.getPowerSource = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.PowerSource} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.PowerSource} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus.prototype.setPowerSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus;
  return proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.DetectionModeSetting.DetectionMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional DetectionModeSetting.DetectionMode mode = 1;
 * @return {!proto.com.alfredcamera.protobuf.DetectionModeSetting.DetectionMode}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.prototype.getMode = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.DetectionModeSetting.DetectionMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.DetectionModeSetting.DetectionMode} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    issueDetected: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus;
  return proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssueDetected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssueDetected();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool issue_detected = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.prototype.getIssueDetected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus.prototype.setIssueDetected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 settings_revision = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.getSettingsRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.setSettingsRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool disabled = 2;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.setDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool mic_off = 3;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.getMicOff = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.setMicOff = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional PowerSupplyStatus power_status = 4;
 * @return {?proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.getPowerStatus = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus, 4));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraRuntimeStatus.PowerSupplyStatus|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
*/
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.setPowerStatus = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.clearPowerStatus = function() {
  return this.setPowerStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.hasPowerStatus = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Membership membership_status = 5;
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.Membership}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.getMembershipStatus = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.Membership} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus.Membership} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.setMembershipStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional DetectorStatus detector_status = 6;
 * @return {?proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.getDetectorStatus = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus, 6));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraRuntimeStatus.DetectorStatus|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
*/
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.setDetectorStatus = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.clearDetectorStatus = function() {
  return this.setDetectorStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.hasDetectorStatus = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional HealthStatus health_status = 7;
 * @return {?proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.getHealthStatus = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus, 7));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraRuntimeStatus.HealthStatus|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
*/
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.setHealthStatus = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.clearHealthStatus = function() {
  return this.setHealthStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.hasHealthStatus = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated string connected_users = 8;
 * @return {!Array<string>}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.getConnectedUsersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.setConnectedUsersList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.addConnectedUsers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.clearConnectedUsersList = function() {
  return this.setConnectedUsersList([]);
};


/**
 * repeated int32 status_codes = 15;
 * @return {!Array<number>}
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.getStatusCodesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.setStatusCodesList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.addStatusCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.alfredcamera.protobuf.CameraRuntimeStatus} returns this
 */
proto.com.alfredcamera.protobuf.CameraRuntimeStatus.prototype.clearStatusCodesList = function() {
  return this.setStatusCodesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.LiveSessionStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.LiveSessionStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    featureAvail: (f = msg.getFeatureAvail()) && proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.toObject(includeInstance, f),
    lensSetting: (f = msg.getLensSetting()) && messaging_camera_settings_pb.CameraLensSetting.toObject(includeInstance, f),
    micSetting: (f = msg.getMicSetting()) && messaging_camera_settings_pb.CameraMicrophoneSetting.toObject(includeInstance, f),
    lowlightSetting: (f = msg.getLowlightSetting()) && messaging_camera_settings_pb.LowLightFilterSetting.toObject(includeInstance, f),
    width: jspb.Message.getFieldWithDefault(msg, 5, 0),
    height: jspb.Message.getFieldWithDefault(msg, 6, 0),
    torchState: (f = msg.getTorchState()) && messaging_live_control_pb.TorchControl.TorchState.toObject(includeInstance, f),
    orientationState: (f = msg.getOrientationState()) && messaging_live_control_pb.OrientationControl.OrientationState.toObject(includeInstance, f),
    sirenState: (f = msg.getSirenState()) && messaging_live_control_pb.SirenControl.SirenState.toObject(includeInstance, f),
    pttState: (f = msg.getPttState()) && messaging_live_control_pb.PushToTalkControl.PushToTalkState.toObject(includeInstance, f),
    recordingState: (f = msg.getRecordingState()) && proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.toObject(includeInstance, f),
    zoomState: (f = msg.getZoomState()) && messaging_live_control_pb.ZoomControl.ZoomState.toObject(includeInstance, f),
    focusState: (f = msg.getFocusState()) && messaging_live_control_pb.FocusControl.FocusState.toObject(includeInstance, f),
    resolutionState: jspb.Message.getFieldWithDefault(msg, 15, 0),
    logs: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.LiveSessionStatus;
  return proto.com.alfredcamera.protobuf.LiveSessionStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.LiveSessionStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.deserializeBinaryFromReader);
      msg.setFeatureAvail(value);
      break;
    case 2:
      var value = new messaging_camera_settings_pb.CameraLensSetting;
      reader.readMessage(value,messaging_camera_settings_pb.CameraLensSetting.deserializeBinaryFromReader);
      msg.setLensSetting(value);
      break;
    case 3:
      var value = new messaging_camera_settings_pb.CameraMicrophoneSetting;
      reader.readMessage(value,messaging_camera_settings_pb.CameraMicrophoneSetting.deserializeBinaryFromReader);
      msg.setMicSetting(value);
      break;
    case 4:
      var value = new messaging_camera_settings_pb.LowLightFilterSetting;
      reader.readMessage(value,messaging_camera_settings_pb.LowLightFilterSetting.deserializeBinaryFromReader);
      msg.setLowlightSetting(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setWidth(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHeight(value);
      break;
    case 7:
      var value = new messaging_live_control_pb.TorchControl.TorchState;
      reader.readMessage(value,messaging_live_control_pb.TorchControl.TorchState.deserializeBinaryFromReader);
      msg.setTorchState(value);
      break;
    case 8:
      var value = new messaging_live_control_pb.OrientationControl.OrientationState;
      reader.readMessage(value,messaging_live_control_pb.OrientationControl.OrientationState.deserializeBinaryFromReader);
      msg.setOrientationState(value);
      break;
    case 9:
      var value = new messaging_live_control_pb.SirenControl.SirenState;
      reader.readMessage(value,messaging_live_control_pb.SirenControl.SirenState.deserializeBinaryFromReader);
      msg.setSirenState(value);
      break;
    case 10:
      var value = new messaging_live_control_pb.PushToTalkControl.PushToTalkState;
      reader.readMessage(value,messaging_live_control_pb.PushToTalkControl.PushToTalkState.deserializeBinaryFromReader);
      msg.setPttState(value);
      break;
    case 11:
      var value = new proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.deserializeBinaryFromReader);
      msg.setRecordingState(value);
      break;
    case 12:
      var value = new messaging_live_control_pb.ZoomControl.ZoomState;
      reader.readMessage(value,messaging_live_control_pb.ZoomControl.ZoomState.deserializeBinaryFromReader);
      msg.setZoomState(value);
      break;
    case 13:
      var value = new messaging_live_control_pb.FocusControl.FocusState;
      reader.readMessage(value,messaging_live_control_pb.FocusControl.FocusState.deserializeBinaryFromReader);
      msg.setFocusState(value);
      break;
    case 15:
      var value = /** @type {!proto.com.alfredcamera.protobuf.ResolutionControl.ResolutionState} */ (reader.readEnum());
      msg.setResolutionState(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.LiveSessionStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.LiveSessionStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFeatureAvail();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.serializeBinaryToWriter
    );
  }
  f = message.getLensSetting();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messaging_camera_settings_pb.CameraLensSetting.serializeBinaryToWriter
    );
  }
  f = message.getMicSetting();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      messaging_camera_settings_pb.CameraMicrophoneSetting.serializeBinaryToWriter
    );
  }
  f = message.getLowlightSetting();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      messaging_camera_settings_pb.LowLightFilterSetting.serializeBinaryToWriter
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getTorchState();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      messaging_live_control_pb.TorchControl.TorchState.serializeBinaryToWriter
    );
  }
  f = message.getOrientationState();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      messaging_live_control_pb.OrientationControl.OrientationState.serializeBinaryToWriter
    );
  }
  f = message.getSirenState();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      messaging_live_control_pb.SirenControl.SirenState.serializeBinaryToWriter
    );
  }
  f = message.getPttState();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      messaging_live_control_pb.PushToTalkControl.PushToTalkState.serializeBinaryToWriter
    );
  }
  f = message.getRecordingState();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.serializeBinaryToWriter
    );
  }
  f = message.getZoomState();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      messaging_live_control_pb.ZoomControl.ZoomState.serializeBinaryToWriter
    );
  }
  f = message.getFocusState();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      messaging_live_control_pb.FocusControl.FocusState.serializeBinaryToWriter
    );
  }
  f = message.getResolutionState();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getLogs();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.toObject = function(includeInstance, msg) {
  var f, obj = {
    resolutionChange: jspb.Message.getFieldWithDefault(msg, 1, 0),
    zoom: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability;
  return proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setResolutionChange(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setZoom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResolutionChange();
  if (f !== 0) {
    writer.writeSint32(
      1,
      f
    );
  }
  f = message.getZoom();
  if (f !== 0) {
    writer.writeSint32(
      2,
      f
    );
  }
};


/**
 * optional sint32 resolution_change = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.prototype.getResolutionChange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.prototype.setResolutionChange = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sint32 zoom = 2;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.prototype.getZoom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability.prototype.setZoom = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.toObject = function(includeInstance, msg) {
  var f, obj = {
    recording: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState;
  return proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRecording(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecording();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool recording = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.prototype.getRecording = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState.prototype.setRecording = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional LiveFeatureAvailability feature_avail = 1;
 * @return {?proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getFeatureAvail = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability, 1));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.LiveSessionStatus.LiveFeatureAvailability|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setFeatureAvail = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearFeatureAvail = function() {
  return this.setFeatureAvail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasFeatureAvail = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CameraLensSetting lens_setting = 2;
 * @return {?proto.com.alfredcamera.protobuf.CameraLensSetting}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getLensSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraLensSetting} */ (
    jspb.Message.getWrapperField(this, messaging_camera_settings_pb.CameraLensSetting, 2));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraLensSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setLensSetting = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearLensSetting = function() {
  return this.setLensSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasLensSetting = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CameraMicrophoneSetting mic_setting = 3;
 * @return {?proto.com.alfredcamera.protobuf.CameraMicrophoneSetting}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getMicSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraMicrophoneSetting} */ (
    jspb.Message.getWrapperField(this, messaging_camera_settings_pb.CameraMicrophoneSetting, 3));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraMicrophoneSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setMicSetting = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearMicSetting = function() {
  return this.setMicSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasMicSetting = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional LowLightFilterSetting lowlight_setting = 4;
 * @return {?proto.com.alfredcamera.protobuf.LowLightFilterSetting}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getLowlightSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.LowLightFilterSetting} */ (
    jspb.Message.getWrapperField(this, messaging_camera_settings_pb.LowLightFilterSetting, 4));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.LowLightFilterSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setLowlightSetting = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearLowlightSetting = function() {
  return this.setLowlightSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasLowlightSetting = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint32 width = 5;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 height = 6;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional TorchControl.TorchState torch_state = 7;
 * @return {?proto.com.alfredcamera.protobuf.TorchControl.TorchState}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getTorchState = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.TorchControl.TorchState} */ (
    jspb.Message.getWrapperField(this, messaging_live_control_pb.TorchControl.TorchState, 7));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.TorchControl.TorchState|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setTorchState = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearTorchState = function() {
  return this.setTorchState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasTorchState = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional OrientationControl.OrientationState orientation_state = 8;
 * @return {?proto.com.alfredcamera.protobuf.OrientationControl.OrientationState}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getOrientationState = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.OrientationControl.OrientationState} */ (
    jspb.Message.getWrapperField(this, messaging_live_control_pb.OrientationControl.OrientationState, 8));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.OrientationControl.OrientationState|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setOrientationState = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearOrientationState = function() {
  return this.setOrientationState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasOrientationState = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional SirenControl.SirenState siren_state = 9;
 * @return {?proto.com.alfredcamera.protobuf.SirenControl.SirenState}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getSirenState = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.SirenControl.SirenState} */ (
    jspb.Message.getWrapperField(this, messaging_live_control_pb.SirenControl.SirenState, 9));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.SirenControl.SirenState|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setSirenState = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearSirenState = function() {
  return this.setSirenState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasSirenState = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional PushToTalkControl.PushToTalkState ptt_state = 10;
 * @return {?proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getPttState = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState} */ (
    jspb.Message.getWrapperField(this, messaging_live_control_pb.PushToTalkControl.PushToTalkState, 10));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setPttState = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearPttState = function() {
  return this.setPttState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasPttState = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional CameraRecordingState recording_state = 11;
 * @return {?proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getRecordingState = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState, 11));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.LiveSessionStatus.CameraRecordingState|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setRecordingState = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearRecordingState = function() {
  return this.setRecordingState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasRecordingState = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional ZoomControl.ZoomState zoom_state = 12;
 * @return {?proto.com.alfredcamera.protobuf.ZoomControl.ZoomState}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getZoomState = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.ZoomControl.ZoomState} */ (
    jspb.Message.getWrapperField(this, messaging_live_control_pb.ZoomControl.ZoomState, 12));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.ZoomControl.ZoomState|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setZoomState = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearZoomState = function() {
  return this.setZoomState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasZoomState = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional FocusControl.FocusState focus_state = 13;
 * @return {?proto.com.alfredcamera.protobuf.FocusControl.FocusState}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getFocusState = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.FocusControl.FocusState} */ (
    jspb.Message.getWrapperField(this, messaging_live_control_pb.FocusControl.FocusState, 13));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.FocusControl.FocusState|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
*/
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setFocusState = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.clearFocusState = function() {
  return this.setFocusState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.hasFocusState = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional ResolutionControl.ResolutionState resolution_state = 15;
 * @return {!proto.com.alfredcamera.protobuf.ResolutionControl.ResolutionState}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getResolutionState = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.ResolutionControl.ResolutionState} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.ResolutionControl.ResolutionState} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setResolutionState = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string logs = 16;
 * @return {string}
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.getLogs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.alfredcamera.protobuf.LiveSessionStatus} returns this
 */
proto.com.alfredcamera.protobuf.LiveSessionStatus.prototype.setLogs = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.CameraStatusControls = {
  CAMERA_RUNTIME_STATUS: 0,
  LIVE_SESSION_STATUS: 1
};

goog.object.extend(exports, proto.com.alfredcamera.protobuf);
